import React, { useEffect, useState } from "react";
import { BaseUrl } from "../../Constant/Config";
import axios from "axios";
import Loading from "../Error Modal/Loading";
import Header from "../Header/Header";
import Wordlist from "./Wordlist";
import AddWord from "../AddWord/Addword";
import { useHistory } from "react-router";
export default function Wordbank() {
  // State
  const history = useHistory();
  const [wordList, setWordList] = useState();
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const getWordList = () => {
      setLoading(true);
      axios
        .get(`${BaseUrl}/admin/word/list?api_token=${localStorage.getItem(
          "token"
        )}`)
        .then((res) => {
          setWordList(res.data.data.reverse());

          setLoading(false);
        })
        .catch((error) => {
          return error.response.data.status === 401 ? history.push("/login") : null;
        }
        );
    }
    getWordList();
  }, []);

  return (
    <>
      <Header />
      <div className="container Wordbankpage">
        <div className="row mt-5">
          <div className="col-12">
            <button className="btn btn_AddWord">
              <AddWord setWord={setWordList} />
            </button>
            <Wordlist setWordList={setWordList} wordList={wordList} />
          </div>
        </div>
      </div>
      {loading && <Loading isOpen={loading} />}
    </>
  );
}
